import {
  Component,
  OnInit,
  ViewChild,
  Renderer2,
  ChangeDetectorRef,
} from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { SpeechRecognitionService } from "src/app/services/speechRecognition.service";
import { DataService } from "src/app/services/data.service";
import { UntypedFormControl } from "@angular/forms";
import { FilterModel } from "src/app/Models/filter.model";
import {
  AttachmentLinksModel,
  AttachmentInfoModel,
  SearchTypeModel,
} from "src/app/Models/AttachmentInfo.model";
import { CustomSearchService } from "src/app/services/custom-search.service";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { CategoryEmitterModel } from "src/app/Models/categoryEmitter.model"; //src/app/models/CategoryEmitter
import { SearchresultsComponent } from "../searchresults/searchresults.component";
import { SearchPageService } from "./searchpage.service";
import { InfoDialogComponent } from "src/app/components/info-dialog/info-dialog.component";
import { AuthServiceService } from "src/app/services/auth-service.service";
import * as introJs from "intro.js";

declare var $: any;

@Component({
  selector: "app-searchpage",
  templateUrl: "./searchpage.component.html",
  styleUrls: ["./searchpage.component.css"],
})
export class SearchpageComponent implements OnInit {
  public cardsFlag: boolean;
  public role: string;
  public showMic = true;
  public searchText = (this.searchPageService.searchTerm = "");
  public selectedGroupBy = new UntypedFormControl();
  public tileDisplay = true;
  public searchFilters = new CategoryEmitterModel();
  public fileName: any;
  public demoFilterFlag: boolean;
  public linkResults: AttachmentLinksModel[] = new Array<AttachmentLinksModel>();
  public selectedFiles = [];
  public selectAllFlag: boolean;
  public selectAllDivFlag: boolean;
  public showActionDropdown: boolean;
  public searchConfigurations: SearchTypeModel;
  public downloadSelection: any;
  public displayedColumns = [
    "projectName",
    "projectManager",
    "bdContact",
    "geography",
    "score",
    "options",
  ];
  public filterList: FilterModel[] = [
    {
      name: "Tags",
      value: "fileInfo.tags",
    },
    {
      name: "Region",
      value: "fileInfo.region",
    },
    {
      name: "Geography",
      value: "fileInfo.geography",
    },
    {
      name: "Content",
      value: "attachment.content",
    },
    {
      name: "Project Manager",
      value: "fileInfo.projectManager",
    },
    {
      name: "Project Name",
      value: "fileInfo.projectName",
    },
    {
      name: "BD Contact",
      value: "fileInfo.bdContact",
    },
    {
      name: "Client",
      value: "fileInfo.client",
    },
  ];

  public groupByList = [
    {
      name: "Region",
      value: "fileInfo.region",
    },
    {
      name: "Geography",
      value: "fileInfo.geography",
    },
    {
      name: "Project Manager",
      value: "fileInfo.projectManager",
    },
    {
      name: "BD Contact",
      value: "fileInfo.bdContact",
    },
    {
      name: "Client",
      value: "fileInfo.client",
    },
  ];
  selectedFiltersFlag: any;
  zipFiles: any;
  showDemo: boolean;
  showFilterDemo: boolean;
  demoService: any;
  public demoIconFlag = true;
  isDashBoardPage: boolean = true;
  @ViewChild(SearchresultsComponent) searchResults!: SearchresultsComponent;

  constructor(
    public renderer: Renderer2,
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthServiceService,
    private data: DataService,
    // tslint:disable-next-line: align
    private speechRecognitionService: SpeechRecognitionService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    // tslint:disable-next-line: align
    private customSearchService: CustomSearchService,
    private cd: ChangeDetectorRef,
    private _http: HttpClient,
    public searchPageService: SearchPageService
  ) {
    this.role = this.auth.getRole();
    this.selectAllFlag = false;
    this.selectAllDivFlag = false;
    this.searchConfigurations = new SearchTypeModel();
  }

  dataSource = new MatTableDataSource<AttachmentInfoModel>();

  ngOnInit() {
    this.cardsFlag = false;
    this.data.showListView.subscribe((message) => {
      this.tileDisplay = message;
    });
    this.searchText = null
    this.searchPageService.searchTerm = ""
    this.searchPageService.filterButtonFlag = false
    this.searchPageService.ictSearchTerm = "";
    this.searchPageService.searchOptions.searchTerm = "";
  }
  // tslint:disable-next-line: use-life-cycle-interface
  ngAfterViewInit() {
    const currentUrl = this.router.routerState.snapshot.url;
    if (
      this.searchPageService.searchOptions &&
      this.searchPageService.searchOptions.searchTerm !== "" &&
      this.searchPageService.searchOptions.searchTerm !== undefined
    ) {
      this.searchText = this.searchPageService.searchOptions.searchTerm;
      this.searchFilters.filteredList =
        this.searchPageService.searchOptions.filterList;
      this.searchFilters.groupBy = this.searchPageService.searchOptions.groupBy;
      this.searchFilters.operator =
        this.searchPageService.searchOptions.operator;
      this.searchFilters.displayType =
        this.searchPageService.searchOptions.displayType;

      this.cd.detectChanges();
    } else if (this.router.url === "/Home/KMSPortal/Case%20Studies" || this.router.url === "/Home/KMS%20Portal/Case%20Studies") {
      this.searchResults.fetchResultsByCaseStudy();
    } else if (currentUrl.startsWith("/Home/KMSPortal/Search")) {
      this.route.params.subscribe((params) => {
        this.searchText = params['searchterm']
      })
      let apiSearchText = this.searchText.trim();
      this.searchConfigurations.searchTerm = apiSearchText;
      this.searchConfigurations.operator = this.searchFilters.operator;
      this.searchConfigurations.groupBy = this.searchFilters.groupBy;
      this.searchConfigurations.displayType = this.searchFilters.displayType;
      this.searchConfigurations.activeProjectsFilter =
        this.searchFilters.activeProjects;
      this.searchConfigurations.filterList = this.searchFilters.filteredList;
      this.searchResults.searchDoc(this.searchConfigurations);
    }
    else if (this.router.url == "/Home/KMS%20Portal") {
      this.isDashBoardPage = false;
      this.demoService = this.auth.demo.subscribe((res) => {
        if (res) {
          this.openIntroJs();
          this.searchPageService.filterButtonFlag = true;
          this.demoFilterFlag = true;
        }
      });

      if (this.showDemo) {
        this.auth.showDemo = false;
        this.showDemo = false;
        this.openIntroJs();
      }
    }
    else if (this.router.url !== "/Home/KMSPortal") {
      this.searchProjectsWithSpeciality();
    }
    if (this.router.url == "/Home/KMSPortal") {
      this.isDashBoardPage = false;
      this.demoService = this.auth.demo.subscribe((res) => {
        if (res) {
          this.openIntroJs();
          this.searchPageService.filterButtonFlag = true;
          this.demoFilterFlag = true;
        }
      });

      if (this.showDemo) {
        this.auth.showDemo = false;
        this.showDemo = false;
        this.openIntroJs();
      }
    }
  }

  searchProjectsWithSpeciality() {
    this.searchResults.searchResultsViewFlag = true;
      let speciality: string;
      this.route.paramMap.subscribe((params) => {
        speciality = params.get("speciality");
      });
      this.searchResults.getProjectsBySpeciality(speciality);
  }

  openIntroJs() {
    this.searchPageService.filterButtonFlag = true;
    this.demoFilterFlag = true;
    const intro = introJs();
    intro.setOptions({
      steps: [
        {
          element: "#all_tokens",
          intro:
            "Check this to get results that contain all elements of the search query.",
          position: "right",
          highlightClass: "background-transparent",
        },

        {
          element: "#voice-search",
          // tslint:disable-next-line: max-line-length
          intro:
            "Use voice-enabled search queries. It also works with the All Tokens feature.<br> 1st Click - starts recording.<br> 2nd Click – sends a query.",
          position: "bottom",
          highlightClass: "background-transparent",
        },
        {
          element: "#text-search",
          intro:
            "Click this for text search queries. It also works with the All Tokens feature.",
          position: "bottom",
          highlightClass: "background-transparent",
        },
        {
          element: "#sidebarCollapse1",
          intro:
            "Filter results based on various categories such as tags, content, clients, PM, vertical project status, and more.",
          position: "left",
          highlightClass: "background-transparent",
        },
        {
          element: "#carousel",
          intro:
            "Access material based on the various categories of information such as industries, services, case studies, and more.",
          position: "bottom",
        },
        {
          element: "#speciality",
          intro:
            "Find case studies on specific industry verticals we serve and specialty areas.",
          position: "bottom",
        },
      ],
    });

    window.scroll(0, 0);

    intro.start();

    intro.onexit(() => {
      this.demoFilterFlag = false;
      this.searchPageService.filterButtonFlag = false;
    });
  }

  selectForDownload(attachment) {
  }

  zipAndDownload() { }

  selectAll() {
    this.selectAllFlag = !this.selectAllFlag;
    if (
      this.searchResults.groupedSearchResults &&
      this.searchResults.groupedSearchResults.length > 0 &&
      this.searchResults.groupedSearchResults.length < 60
    ) {
      this.searchResults.groupedSearchResults.forEach((res) => {
        res.attachments.forEach((res1) => {
          if (this.searchResults.selectedFiles.length < 60) {
            this.searchResults.selectAttachment(res1);
            res1.checked = this.selectAllFlag;
          }
        });
      });
    } else if (
      this.searchResults.searchResults &&
      this.searchResults.searchResults.length > 0 &&
      this.searchResults.searchResults.length < 60
    ) {
      this.searchResults.searchResults.forEach((res) => {
        if (this.searchResults.selectedFiles.length < 60) {
          this.searchResults.selectAttachment(res);
          res.checked = this.selectAllFlag;
        }
      });
    } else {
      ;
      this.selectAllFlag = false;
      const dialogRef = this.dialog.open(InfoDialogComponent, {
        width: "280px",
        // tslint:disable-next-line: max-line-length
        data: {
          message: "Maximum selection limit of 60 has been exceeded.",
          class: "text-danger",
        },
      });
    }
  }

  getFilterValues(value: any) {
    this.searchFilters = value;

    this.searchFiles();
  }

  hideDemo(event) {
    this.demoIconFlag = event;
    this.cd.detectChanges();
  }

  handleKeyUp(event: KeyboardEvent) {
    if (event.key === 'Backspace' && this.searchText === '') {
      this.searchText = '';
      this.searchFiles('yes');
    }
  }

  clearSearch() {
    this.searchText = '';
    this.searchFiles('yes');
  }

  async searchFiles(event?: string) {
    const currentUrl: NavigationEnd = this.router.routerState.snapshot.url as unknown as NavigationEnd;
    if (
      this.searchText !== "" &&
      this.searchText !== undefined &&
      this.searchText !== null
    ) {
      this.demoIconFlag = false;

      this.searchPageService.filterButtonFlag = true;
      this.cardsFlag = true;
      this.selectAllFlag = false;
      let apiSearchText = this.searchText.trim();

      if (this.searchPageService.searchOptions.searchTerm) {
        apiSearchText = apiSearchText.replace(/~/g, "");
        apiSearchText = apiSearchText.replace(/ AND /g, " ");
        this.searchText = apiSearchText;
      }
      if (
        this.searchFilters.operator ||
        this.searchPageService.searchOptions.operator
      ) {
        apiSearchText = apiSearchText.replace(/ /g, " AND ");
      }
      ;
      this.searchConfigurations.searchTerm = apiSearchText;
      this.searchConfigurations.operator = this.searchFilters.operator;
      this.searchConfigurations.groupBy = this.searchFilters.groupBy;
      this.searchConfigurations.displayType = this.searchFilters.displayType;
      this.searchConfigurations.activeProjectsFilter =
        this.searchFilters.activeProjects;
      this.searchConfigurations.filterList = this.searchFilters.filteredList;
      this.searchResults.searchDoc(this.searchConfigurations);
      if (
        `${currentUrl}` === '/Home/KMS%20Portal' ||
        `${currentUrl}` === '/Home/KMSPortal'
      ) {
        if (!this.searchResults.verticalOption) {
          await this.router.navigate([`/Home/KMSPortal/Search/${apiSearchText}`]);
        }
      }
      this.cd.detectChanges();
    } else if (event) {
      if (
        `${currentUrl}` === '/Home/KMS%20Portal' ||
        `${currentUrl}` === '/Home/KMSPortal'
      ) {
        this.searchPageService.searchOptions.searchTerm = "";
        this.router.navigate(["/Home/KMSPortal"]);
      } else if (
        this.router.url.startsWith('/Home/KMSPortal') &&
        this.router.url !== '/Home/KMSPortal' &&
        !this.router.url.includes('Case%20Studies') &&
        !this.router.url.includes('Case Studies')
      ) {
        this.searchPageService.searchOptions.searchTerm = "";
        this.searchProjectsWithSpeciality();
      } else {
        this.searchPageService.searchOptions.searchTerm = "";
        this.searchResults.fetchResultsByCaseStudy();
      }
    }
  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngOnDestroy() {
    this.speechRecognitionService.destroySpeechObject();
  }

  checkAllTokens() {
    this.searchFilters.operator = !this.searchFilters.operator;
  }

  activateSpeech(): void {
    this.showMic = false;
    if (this.searchText) {
      this.searchText = "";
    }

    this.speechRecognitionService.record().subscribe(
      // listener
      (value) => {
        this.searchText = this.searchText + value;
        this.stopSpeech();
        this.searchFiles(value);
      },
      (err) => {
        if (err.error === "no-speech") {
          this.activateSpeech();
        }
      },

    );
  }

  downloadAll() {
    if (this.searchResults.mailMultipleAttachments.length > 0) {
      this.searchResults.downloadAttachments();
    } else {
      const dialogRef = this.dialog.open(InfoDialogComponent, {
        width: "280px",
        data: {
          message: "Please select atleast one case study to Download",
          class: "text-danger",
        },
      });
    }
  }

  sendMultipleAttachments() {
    if (this.searchResults.mailMultipleAttachments.length > 0) {
      this.searchResults.sendMail(
        this.searchResults.mailMultipleAttachments,
        ""
      );
    } else {
      const dialogRef = this.dialog.open(InfoDialogComponent, {
        width: "280px",
        data: {
          message: "Please select atleast one case study to send an E-mail",
          class: "text-danger",
        },
      });
    }
  }

  showDropDownOptions() {
    if (this.searchResults.mailMultipleAttachments.length > 0) {
      this.showActionDropdown = true;
    }
  }

  stopSpeech() {
    this.speechRecognitionService.destroySpeechObject();
    this.showMic = true;
  }

  dismissSidebar() {
    $("#sidebar").removeClass("active");
    $("#sidebar_r").removeClass("active");
    $(".overlay").removeClass("active");
  }

  openRightSidebar() {

    $("#sidebar_r").addClass("active");
    $(".overlay").addClass("active");
    $(".collapse.in").toggleClass("in");
    $("a[aria-expanded=true]").attr("aria-expanded", "false");
  }

  openFilterIntoJs() {
    const intro = introJs();
    intro.setOptions({
      steps: [
        {
          element: "#categoryBarMenu",
          intro: "Select the required category to be applied on the result",
          position: "left",
        },
        {
          element: "#groupByMenu",
          intro: "Select the requrired groups to be applied on the result",
          position: "left",
        },
        {
          element: "#activeProjects",
          intro: "Click here for active projects",
          position: "left",
        },
        {
          element: "#displayOptions",
          intro: "Grid View or Table View",
          position: "left",
        },
      ],
    });

    intro.start();
  }
}
